/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Feat_1_DescInputs */

const en_nfp_feat_1_desc = /** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace messy Facebook Groups. Launch a private, authenticated community chat for your congregation right on your own custom domain.`)
};

const es_nfp_feat_1_desc = /** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplaza los grupos de Facebook. Lanza un chat comunitario privado para tu congregación en tu propio dominio.`)
};

const fr_nfp_feat_1_desc = /** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacez les groupes Facebook désordonnés. Lancez un chat communautaire privé et authentifié pour votre congrégation directement sur votre propre domaine personnalisé.`)
};

const de_nfp_feat_1_desc = /** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetze unordentliche Facebook-Gruppen. Starte einen privaten, authentifizierten Community-Chat.`)
};

const id_nfp_feat_1_desc = /** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gantikan Grup Facebook yang berantakan. Luncurkan obrolan komunitas pribadi yang diautentikasi untuk jemaat Anda langsung di domain kustom Anda sendiri.`)
};

/** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */
const ja_nfp_feat_1_desc = en_nfp_feat_1_desc;

/** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */
const zh_nfp_feat_1_desc = en_nfp_feat_1_desc;

/** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */
const ar_nfp_feat_1_desc = en_nfp_feat_1_desc;

/** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */
const it_nfp_feat_1_desc = en_nfp_feat_1_desc;

/** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */
const ru_nfp_feat_1_desc = en_nfp_feat_1_desc;

/** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */
const pt_nfp_feat_1_desc = en_nfp_feat_1_desc;

/** @type {(inputs: Nfp_Feat_1_DescInputs) => LocalizedString} */
const ko_nfp_feat_1_desc = en_nfp_feat_1_desc;

/**
* | output |
* | --- |
* | "Replace messy Facebook Groups. Launch a private, authenticated community chat for your congregation right on your own custom domain." |
*
* @param {Nfp_Feat_1_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_feat_1_desc = /** @type {((inputs?: Nfp_Feat_1_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Feat_1_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_feat_1_desc(inputs)
	if (locale === "es") return es_nfp_feat_1_desc(inputs)
	if (locale === "fr") return fr_nfp_feat_1_desc(inputs)
	if (locale === "de") return de_nfp_feat_1_desc(inputs)
	if (locale === "ja") return ja_nfp_feat_1_desc(inputs)
	if (locale === "zh") return zh_nfp_feat_1_desc(inputs)
	if (locale === "ar") return ar_nfp_feat_1_desc(inputs)
	if (locale === "id") return id_nfp_feat_1_desc(inputs)
	if (locale === "it") return it_nfp_feat_1_desc(inputs)
	if (locale === "ru") return ru_nfp_feat_1_desc(inputs)
	if (locale === "pt") return pt_nfp_feat_1_desc(inputs)
	return ko_nfp_feat_1_desc(inputs)
});